/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,r){this.tile=t,this.version=r,this._abortController=new AbortController}get key(){return this.tile.key}get signal(){return this._abortController.signal}abort(){this._abortController.abort()}}export{t as FeatureTileSubscription};
